import React from 'react';
import $ from 'jquery';
import * as ReactBootstrap from 'react-bootstrap';
import { Button, Modal, FormControl } from 'react-bootstrap';

class CreateExtraction extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.hideHandler = this.hideHandler.bind(this);
        this.showHandler = this.showHandler.bind(this);
        this.enteredHandler = this.enteredHandler.bind(this);
        this.onExtractionCreate = this.onExtractionCreate.bind(this);
        this.fetchUsers = this.fetchUsers.bind(this);
        this.state = {
            show: false,
            extractionReferenceValid: true,
            input: '',
            errorMessage: '',
            success: false,
            newExtraction: {
                name: '',
                userId: -1,
            },
            users: [],
        };
       
    }

    hideHandler() {
        this.setState({ show: false, newExtraction: { name: "", userId: -1 } });
    }

    showHandler() {
        this.setState({ show: true });
    }

    enteredHandler() {
        if (this.createExtractionRef && this.createExtractionRef.focus) {
            this.createExtractionRef.focus();
        }
    }

    onExtractionCreate() {
        this.props.extractionService.createExtraction(this.props.projectId, this.state.newExtraction.name, this.state.newExtraction.userId)
        .then(result => {
            const { extraction, errorMessage } = result;
            if (extraction) {
                this.props.onExtractionCreated(extraction);
                this.setState({ 
                    errorMessage: null,
                    extractionReferenceValid: true,            
                    newExtraction: {
                        name: '',
                        userId: -1,
                    },
                });
                this.hideHandler();
            } else {
                this.setState({ 
                    errorMessage: errorMessage,
                    extractionReferenceValid: false 
                });
            }
        })
        .catch(error => {
            console.error('Failed creating extraction:', error);
        });
    }

    fetchUsers = (projectId) => {
        $.get('/api/v1/projects/' + projectId + '/users', (data) => {
            this.setState({ users: data });
        }).fail((xhr) => {
            this.setState({ errorMessage: 'Failed to fetch users' });
        });
    };

    handleExtractionInputChange = (field, value) => {
        this.setState(prevState => ({
            newExtraction: {
                ...prevState.newExtraction,
                [field]: value
            }
        }));
        if (field === 'name') {
            this.setState({ extractionReferenceValid: true });
        }
    };

    render() {
        const { newExtraction, users } = this.state;
        return (
            <div className="modal-container">
                <Modal
                    show={this.state.show}
                    onHide={this.hideHandler}
                    onEntered={this.enteredHandler}
                    centered
                    // aria-labelledby="contained-modal-title"
                    onKeyPress={(event) => {
                        if (event.key === "Enter") {
                            this.onExtractionCreate();
                        }
                    }}
                >
                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title">
                            Create a new extraction
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                    <ReactBootstrap.Form>
                        <ReactBootstrap.FormGroup>
                            <FormControl
                                ref={(input) => (this.createExtractionRef = input)}
                                type="text"
                                value={newExtraction.name}
                                placeholder="Enter the extraction name"
                                onChange={(e) => this.handleExtractionInputChange('name', e.target.value)}
                                isInvalid={!this.state.extractionReferenceValid}
                            />
                            <FormControl.Feedback type="invalid">
                                Please make sure the extraction name is unique within the Project.
                            </FormControl.Feedback>
                        </ReactBootstrap.FormGroup>
                        <div style={{ height: '1rem' }}></div>
                        <ReactBootstrap.FormGroup>
                            <ReactBootstrap.FormControl
                                as="select"
                                value={newExtraction.userId}
                                onChange={(e) => this.handleExtractionInputChange('userId', e.target.value)}
                            >
                                <option value="">Select a user...</option>
                                {users.map(user => (
                                    <option key={user.id} value={user.id}>
                                        {user.name || user.email}
                                    </option>
                                ))}
                            </ReactBootstrap.FormControl>
                        </ReactBootstrap.FormGroup>
                    </ReactBootstrap.Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.hideHandler}>
                            Cancel
                        </Button>
                        <Button variant="success" onClick={this.onExtractionCreate}>
                            Create Extraction
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default CreateExtraction;